"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var TextField_1 = __importDefault(require("atomicComponents/atoms/Forms/TextField"));
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var QRInput = (0, material_1.styled)(TextField_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        input: {
            height: theme.spacing(3),
            padding: theme.spacing(1, 2),
        },
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(QRInput, {
    variant: 'outlined',
    fullWidth: true,
});
